import iconNewDisabled from '@static/vectors/nav/home-nav_disabled.svg';
import iconNewEnabled from '@static/vectors/nav/home-nav_enabled.svg';

export interface NavItem {
	path: string;
	enabledIcon: string;
	disabledIcon: string;
	altText: string;
}

export const navItems: NavItem[] = [
	{
		path: '/sentinel',
		enabledIcon: iconNewEnabled,
		disabledIcon: iconNewDisabled,
		altText: 'new icon'
	}
];

export function getValidParentRoutes(): string[] {
	return navItems.map((item) => item.path);
}
